import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ProductDetailDrawerStack } from '@grandvisionhq/fun-products';
import { useFeatureToggles } from '@grandvisionhq/state';

const ProductDetailDrawerStackContainer = (props)=>{
    const { isPdpDrawerLayoutEnabled  } = useFeatureToggles();
    if (isPdpDrawerLayoutEnabled) {
        return /*#__PURE__*/ React.createElement(ProductDetailDrawerStack, swcHelpers.extends({}, props));
    }
    // we have to remain backwards compatible with existing pdp v1 layout when drawer is not enabled
    return /*#__PURE__*/ React.createElement(React.Fragment, null, props.children);
};

export { ProductDetailDrawerStackContainer };
//# sourceMappingURL=ProductDetailDrawerStackContainer.js.map
